module.exports = __webpack_public_path__ + "img/section31.c94f6212.png";